import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':jobId'}/jobForm`;

export const ROUTE: RouteDefinition = `${baseRoute}/:jobId/jobForm`;

export const URL = (jobId: number): RouteDefinition => `${baseRoute}/${jobId}/jobForm`;
